module.exports = __webpack_public_path__ + "img/feed_pin2.049058dd.svg";